import { z } from 'zod';

export const allowedRoleIdSchema = z.enum(['user', 'job_architect', 'reviewer', 'viewer']);

export const tenantMemberStatusSchema = z.enum(['active', 'invited']);

export const authTypeSchema = z.enum(['sso', 'pw', 'email_otp']);

export const tenantMemberSchema = z.object({
    id: z.string(),
    authType: z.string().nullish(),
    emailAddress: z.string().nullish(),
    firstName: z.string().nullish(),
    lastName: z.string().nullish(),
    lastSignedIn: z.string().nullish(),
    roles: z.array(z.string()),
    status: z.string(),
});

export const paginationSchema = z.object({
    count: z.number(),
    page: z.number(),
    pages: z.number(),
    size: z.number(),
});

export const paginatedTenantMembersSchema = z.object({
    data: z.array(tenantMemberSchema),
    pagination: paginationSchema,
});

export const invitationMethodSchema = z.enum(['EMAIL', 'SSO']);

export const invitationOptionsSchema = z.object({
    availableMethods: z.array(invitationMethodSchema),
});

export const createInvitationRequestSchema = z.object({
    emailAddress: z.string(),
    roles: z.array(allowedRoleIdSchema).optional(),
});

export const updateUserRolesRequestSchema = z.object({
    roles: z.array(allowedRoleIdSchema),
});
